export const FDK_VERSION = '0.0.1';
